import PropTypes from 'prop-types';
import React from 'react';
import { pageContext } from 'ctm-util-functions';
import { SimpleFlexbox } from '../../../../../flexbox/flexbox';
import { AffixWrapper } from '../../../../../../higher_order_components/affix_wrapper';

/**
 * The features header, renders a layout with passed in product data
 * @param {Object} args Arguments Object containing label and quotes
 * @param {Boolean} args.label - whether or not to render a label cell
 * @param {Array} args.quotes - the array of quotes to render within the affixed header
 * @returns {Node} a wrapping div container for the affixed result column headers
 */
const FeaturesHeaderAffixedWrapper = ({ label = true, quotes, compareModeActive = false }) => {
    const { breakpoint } = pageContext.getProps().pageState;
    const { constructComponents } = pageContext.getProps().director;
    const containsQuotes = !!quotes[0]; // Check that there is a quote to show in the wrapper
    const numOfQuotes = quotes.reduce((acc, curr) => {
        return typeof curr !== 'undefined' ? acc + 1 : acc;
    }, 0);

    return containsQuotes ? (
        <AffixWrapper affixVariant={'no_drop_shadow'} hiddenWhenNotAffixed updateOnPagination includeBuffer>
            <SimpleFlexbox container padding={'none'}>
                <SimpleFlexbox padding={'top'} md={9} xl={breakpoint === 'xl' ? 10 : 12} border="all" bgColor="brand_base_0">
                    <SimpleFlexbox display="flex" border="bottom">
                        {label ? constructComponents(['component_layoutFeatureHeaderLabel']) : null}
                        {quotes.map((quote) => {
                            const stateProps = { product: quote };
                            if (compareModeActive) {
                                return stateProps && stateProps.product ? constructComponents(['component_layoutFeatureHeaderCellAffixed'], { stateProps }) : null;
                            }
                            return constructComponents(['component_layoutFeatureHeaderCellAffixed'], { stateProps, numOfQuotes });
                        })}
                    </SimpleFlexbox>
                </SimpleFlexbox>
            </SimpleFlexbox>
        </AffixWrapper>
    ) : null;
};

FeaturesHeaderAffixedWrapper.propTypes = {
    label: PropTypes.bool,
    quotes: PropTypes.array.isRequired,
    compareModeActive: PropTypes.bool
};

export { FeaturesHeaderAffixedWrapper };
